import { render } from "./ContactView.vue?vue&type=template&id=3a10b672&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=3a10b672&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a10b672"]])

export default __exports__